<template>
<div class="chapter">
<div class="inner_page">
<div id="ebook4252-5.html" xml:lang="en-US">
<div class="Basic-Text-Frame">
<p class="CN para-style-override-10" id="toc_marker-6"><span class="char-style-override-12">Every time you name yourself,</span></p>
<p class="BT-1st-para para-style-override-11"><span class="char-style-override-13">you name someone else.</span></p>
<p class="BT para-style-override-12"><span class="char-style-override-14">Bertolt Brecht</span></p>
<p class="BT para-style-override-13"><span class="char-style-override-13">How can I speak of love, of your Kingdom’s tender hills,</span></p>
<p class="BT para-style-override-14"><span class="char-style-override-13">when I live like a cat on a pole surrounded by water?</span></p>
<p class="BT para-style-override-14"><span class="char-style-override-13">How can I call the hair, hair</span></p>
<p class="BT para-style-override-14"><span class="char-style-override-13">the tooth, tooth</span></p>
<p class="BT para-style-override-14"><span class="char-style-override-13">the tail, tail</span></p>
<p class="BT para-style-override-14"><span class="char-style-override-13">and not ever name the rat?</span></p>
<p class="BT para-style-override-15"><span class="char-style-override-14">Antonio Cisneros, “Oración”</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ebook4252-5.vue?7959484c